

























import {Component, Vue} from 'vue-property-decorator';
import html2canvas from 'html2canvas';
import wxMixin from '@/mixin/wx-mixin';

@Component({
  mixins: [wxMixin]
})
export default class QuestFlagInfoView extends Vue {
  /*显示内容*/
  private text: string = '';
  /*图片路径*/
  private infoSrc: string = '';
  /*长按事件延时器*/
  private touchTime: any;

  created() {
    this.text = this.$route.params.text;
  }

  /**图片加载成功时候才开始画图*/
  canvasImageLoad() {
    this.$nextTick(() => {
      html2canvas(document.getElementById('flag-info')!, {
        backgroundColor: 'transparent',
        allowTaint: true,
        useCORS: true
      }).then(canvas => {

        this.infoSrc = canvas.toDataURL();
      });
    });
  }


}
